<sc-flex vertical fitHeight stretchContent>
    <ng-container *ngIf="showBarrierSelection">
        <div [formGroup]="formGroup" class="no-field-space">
            <sc-flex>
                <sc-checkbox-field formControlName="bookEntrance" labelDictionaryKey="tmc-yard.ui.control.cep.action.book-entrance"></sc-checkbox-field>
                <sc-content-spacer></sc-content-spacer>
                <mat-form-field appearance="fill">
                    <mat-label>
                      <sc-dictionary-label dictionaryKey="tmc-yard.ui.control.cep.label.entrance"></sc-dictionary-label>
                    </mat-label>
                    <mat-select name="entrance" formControlName="entrance">
                        <mat-option *ngFor="let o of entrances" [value]="o">
                            {{o.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </sc-flex>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>
    </ng-container>
    <sc-flex-fitting-content vertical>
        <sc-loading-spinner [isLoading]="isLoading">
            <div class="grid">
                <app-cep-camera-tile class="camera-tile" *ngIf="cameraUrl" [url]="cameraUrl"></app-cep-camera-tile>
                <app-cep-profile-tile *ngFor="let profile of profiles" [profile]="profile"
                    (click)="handleProfileClick(profile);"></app-cep-profile-tile>
            </div>
        </sc-loading-spinner>
    </sc-flex-fitting-content>
</sc-flex>
